import { FC } from 'react'
import { DefaultProps } from '../../common'

type AlertWarningIconProps = DefaultProps & {
  width?: number
  height?: number
}

export const AlertWarningIcon: FC<AlertWarningIconProps> = ({
  className,
  id,
  testId,
  ariaLabel,
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(!ariaLabel ? { 'aria-hidden': true, role: 'presentation' } : {})}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.3" cx="20" cy="20" r="20" fill="#FDC9A6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4014 11.0034C18.5558 9.00229 21.444 9.00229 22.5985 11.0034L29.9528 23.7509C31.1066 25.7509 29.6632 28.2501 27.3542 28.2501H12.6456C10.3366 28.2501 8.89318 25.7509 10.047 23.7509L17.4014 11.0034ZM20.0001 16.25C20.4143 16.25 20.7501 16.5858 20.7501 17V20.75C20.7501 21.1642 20.4143 21.5 20.0001 21.5C19.5859 21.5 19.2501 21.1642 19.2501 20.75V17C19.2501 16.5858 19.5859 16.25 20.0001 16.25ZM20.0001 24.5C20.4143 24.5 20.7501 24.1642 20.7501 23.75C20.7501 23.3358 20.4143 23 20.0001 23C19.5859 23 19.2501 23.3358 19.2501 23.75C19.2501 24.1642 19.5859 24.5 20.0001 24.5Z"
        fill="#FB924D"
      />
    </svg>
  )
}
